var map = {
	"./big-candle.png": 71922,
	"./bollinger-squeeze.png": 69369,
	"./capitulation.png": 59965,
	"./darvas-box.png": 72787,
	"./divergence.png": 98556,
	"./franks.png": 69417,
	"./heiken-ashi.png": 35128,
	"./hhhl.png": 54378,
	"./indicator-desc.png": 68489,
	"./pocket-pivot.png": 81879,
	"./sams-darvas.png": 40848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18708;